import React from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { getLocalCurrencyStr } from '@beef/utils';
import { withRenderFlag } from '@beef/react/enhancers';
import styles from "./styles.pcss";
import { formatDate } from "./utils";
var cn = classNames.bind(styles);
var _StrikePrice = function _StrikePrice(_ref) {
  var nextValue = _ref.nextValue,
    trialEndDate = _ref.trialEndDate;
  var endDate = formatDate(trialEndDate);
  return /*#__PURE__*/React.createElement(Text, {
    className: cn('text'),
    variant: "caption-medium",
    "data-t-id": "components-StrikePrice"
  }, getLocalCurrencyStr(nextValue), " \u0441 ", endDate);
};
export var StrikePrice = withRenderFlag(_StrikePrice);